<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="15.441" height="15.234" viewBox="0 0 15.441 15.234">
		<path d="M8.634.5H.5" fill="none" :stroke="color" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
		<path
			d="M8.413,3.286H2.821"
			transform="translate(0.22 0.265)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
		/>
		<path
			d="M8.193,6.071H5.143"
			transform="translate(0.441 0.529)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
		/>
		<path
			d="M13.975,11l-2.737,2.737L8.5,11"
			transform="translate(0.76 0.997)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
		/>
		<path
			d="M11,.5V14.734"
			transform="translate(0.997)"
			fill="none"
			:stroke="color"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1"
		/>
	</svg>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
export default defineComponent({
	name: 'SortIcon',
	props: {
		color: {
			type: String,
			default: 'var(--el-color-primary)',
		},
	},
});
</script>
